/* ==========================================================================
   Paola & Joy — gift card page
   --------------------------------------------------------------------------
   Everything that makes Shopify actually deliver the card — the property
   names, enabling and disabling the inputs, the server-side errors — belongs
   to Dawn's <recipient-form> element and is deliberately left alone here.
   This file only adds what the 1B design asks for on top: the amount buttons,
   the live card, the character counter, the delivery line, and the one-line
   validation above the button.
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var form = root.querySelector('form');
    var variantInput = root.querySelector('[data-pj-gc-variant]');
    var picks = Array.prototype.slice.call(root.querySelectorAll('[data-pj-gc-pick]'));

    var priceEl = root.querySelector('[data-pj-gc-price]');
    var ctaPrice = root.querySelector('[data-pj-gc-ctaprice]');
    var amountLabel = root.querySelector('[data-pj-gc-amountlabel]');
    var cardAmount = root.querySelector('[data-pj-gc-amount]');
    var cardFor = root.querySelector('[data-pj-gc-for]');

    var panel = root.querySelector('[data-pj-gc-recipient]');
    var errorEl = root.querySelector('[data-pj-gc-error]');
    var fulfil = root.querySelector('[data-pj-gc-fulfil]');

    var checkbox = panel && panel.querySelector('input[type="checkbox"]');
    var nameInput = panel && panel.querySelector('input[name="properties[Recipient name]"]');
    var emailInput = panel && panel.querySelector('input[name="properties[Recipient email]"]');
    var messageInput = panel && panel.querySelector('[name="properties[Message]"]');
    var sendOn = panel && panel.querySelector('input[name="properties[Send on]"]');

    /* ---- Amounts ---------------------------------------------------------
       The button carries its own money strings from Liquid, so the page never
       has to format currency itself. */
    function choose(btn) {
      picks.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      if (variantInput) variantInput.value = btn.dataset.variant;
      if (priceEl) priceEl.textContent = btn.dataset.priceMoney;
      if (ctaPrice) ctaPrice.textContent = btn.dataset.priceShort;
      if (amountLabel) amountLabel.textContent = btn.dataset.priceShort;
      if (cardAmount) cardAmount.textContent = btn.dataset.priceShort;

      /* Keep the URL shareable and the back button honest, the way Dawn does. */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.dataset.variant);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers simply keep the current URL */ }
    }

    picks.forEach(function (btn) {
      btn.addEventListener('click', function () { choose(btn); });
    });

    /* ---- The live card and the delivery line ----------------------------- */
    function firstName() {
      var v = (nameInput && nameInput.value || '').trim();
      return v ? v.split(/\s+/)[0] : '';
    }

    function prettyDate(value) {
      if (!value) return '';
      /* Parsed as local parts, not Date(string): "2026-10-14" is treated as UTC
         and can render as the 13th in Australia. */
      var bits = value.split('-');
      if (bits.length !== 3) return '';
      var d = new Date(+bits[0], +bits[1] - 1, +bits[2]);
      if (isNaN(d)) return '';
      return d.toLocaleDateString(undefined, { day: 'numeric', month: 'long' });
    }

    function paint() {
      var sending = !!(checkbox && checkbox.checked);
      var name = firstName();

      if (panel) panel.classList.toggle('is-open', sending);

      if (cardFor) {
        var show = sending && name;
        cardFor.hidden = !show;
        if (show) cardFor.textContent = 'For ' + name;
      }

      if (fulfil) {
        var who = name || fulfil.dataset.fallback;
        var when = sending && sendOn ? prettyDate(sendOn.value) : '';
        var line;
        if (!sending) {
          line = fulfil.dataset.self;
        } else if (when) {
          line = fulfil.dataset.scheduled.replace('[name]', who).replace('[date]', when);
        } else {
          line = fulfil.dataset.sending.replace('[name]', who);
        }
        fulfil.textContent = line;
      }
    }

    /* ---- Message counter -------------------------------------------------- */
    if (messageInput) {
      var max = parseInt(messageInput.getAttribute('maxlength'), 10) || 200;
      var count = document.createElement('span');
      count.className = 'pj-gc__count';
      /* NOT messageInput.parentNode: that is .field, which is laid out
         column-reverse so the label sits above the input, and appending
         there put the counter above the textarea instead of under it. */
      (messageInput.closest('.recipient-fields__field') || messageInput.parentNode).appendChild(count);

      var tick = function () {
        var n = messageInput.value.length;
        count.textContent = n + ' / ' + max;
        count.classList.toggle('is-full', n >= max);
      };
      messageInput.addEventListener('input', tick);
      tick();
    }

    /* A date in the past is refused by Shopify, so do not offer one. */
    if (sendOn && !sendOn.min) {
      var now = new Date();
      sendOn.min = now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0');
    }

    [checkbox, nameInput, sendOn].forEach(function (el) {
      if (!el) return;
      el.addEventListener('change', paint);
      el.addEventListener('input', paint);
    });

    /* ---- Validation -------------------------------------------------------
       Shopify treats the recipient name as optional. The design uses it on the
       card and in the delivery line, so it is required here — enforced in the
       theme, as the brief specifies. */
    function looksLikeEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    }

    function showError(text) {
      if (!errorEl) return;
      if (text) { errorEl.textContent = text; errorEl.hidden = false; }
      else { errorEl.textContent = ''; errorEl.hidden = true; }
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!checkbox || !checkbox.checked) { showError(''); return; }

        var name = (nameInput && nameInput.value || '').trim();
        var email = (emailInput && emailInput.value || '').trim();
        var badEmail = !email || !looksLikeEmail(email);

        var message = '';
        if (!name && badEmail) message = root.dataset.errBoth;
        else if (!name) message = root.dataset.errName;
        else if (badEmail) message = root.dataset.errEmail;

        if (message) {
          event.preventDefault();
          showError(message);
          (!name ? nameInput : emailInput).focus();
          return;
        }
        showError('');
      });
    }

    paint();
  }

  function boot() { document.querySelectorAll('[data-pj-gc]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pj-gc]').forEach(function (el) {
      el.dataset.ready = 'false';
      init(el);
    });
  });
})();
